import { useTranslation } from "react-i18next";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangleIcon, FileTextIcon, DollarSignIcon, CheckCircleIcon, RotateCcwIcon, ChevronRightIcon, ServerIcon, RefreshCcwIcon, LinkIcon, SettingsIcon } from 'lucide-react';
import { getTenant } from '../../../theme/tokens';
import { mockBills } from '../../bills/mocks/mockBills';
export function Notifications() {
  const {
    t
  } = useTranslation("notifications");
  const navigate = useNavigate();
  const pendingBills = mockBills.filter(b => b.status === 'pending_approval');
  const recentActivity = [{
    id: 1,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 45,000 from John Doe`,
    time: '10 mins ago',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 2,
    type: 'bill',
    title: 'Bill approved',
    desc: 'INV-2026-003 by Simon Verraest',
    time: '1 hour ago',
    icon: CheckCircleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 3,
    type: 'dispute',
    title: 'New dispute opened',
    desc: `${getTenant().currency.code} 1,538.94 - Fraudulent`,
    time: '3 hours ago',
    icon: AlertTriangleIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 4,
    type: 'refund',
    title: 'Refund processed',
    desc: `${getTenant().currency.code} 2,500 to Sarah Smith`,
    time: '5 hours ago',
    icon: RotateCcwIcon,
    color: 'text-gray-600 bg-gray-100'
  }, {
    id: 5,
    type: 'payment',
    title: 'Payment received',
    desc: `${getTenant().currency.code} 12,400 from Acme Corp`,
    time: 'Yesterday',
    icon: DollarSignIcon,
    color: 'text-gray-600 bg-gray-100'
  }];
  return <div data-id="element-6720">
      {/* Page Header */}
      <div className="flex items-center justify-between mb-6" data-id="element-6721">
        <h1 className="text-2xl font-semibold text-gray-900" data-id="element-6722">{t("pages.Notifications.notifications")}</h1>
        <button onClick={() => navigate('/settings')} className="flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 transition-colors shadow-sm" data-id="element-6723">
          
          <SettingsIcon size={14} data-id="element-6724" />
          {t("pages.Notifications.manage_preferences")}
        </button>
      </div>

      {/* Notification Center */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden" data-id="element-6725">
        {/* Section: Urgent */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200" data-id="element-6726">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-6727">
            <span className="w-2 h-2 rounded-full bg-red-500" data-id="element-6728"></span>
            {t("pages.Notifications.urgent_requires_immediate_action")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-6729">
          <button onClick={() => navigate('/disputes/1')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-6730">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6731">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-6732" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-6733">
              <p className="text-sm font-medium text-gray-900" data-id="element-6734">
                {t("pages.Notifications.dispute_dp20240001_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-6735">
                {t("pages.Notifications.usd_10001_fraudulent_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-6736">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-6737">
                {t("pages.Notifications.due_in_2h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-6738" />
            
          </button>
          <button onClick={() => navigate('/disputes/91')} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-6739">
            
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6740">
              <AlertTriangleIcon size={16} className="text-gray-600" data-id="element-6741" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-6742">
              <p className="text-sm font-medium text-gray-900" data-id="element-6743">
                {t("pages.Notifications.dispute_dp20240091_requires_response")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-6744">
                {t("pages.Notifications.usd_153894_duplicate_charge")}
              </p>
            </div>
            <div className="text-right flex-shrink-0" data-id="element-6745">
              <span className="text-xs font-semibold text-red-600 bg-red-50 px-2 py-1 rounded" data-id="element-6746">
                {t("pages.Notifications.due_in_5h")}
              </span>
            </div>
            <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-6747" />
            
          </button>
        </div>

        {/* Section: Bills */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-6748">
          <h3 className="text-xs font-semibold text-gray-700 uppercase tracking-wider flex items-center gap-2" data-id="element-6749">
            <span className="w-2 h-2 rounded-full bg-[#FF4500]" data-id="element-6750"></span>
            {t("pages.Notifications.bills_pending_approval")} {pendingBills.length} {t("pages.Notifications.items")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-6751">
          {pendingBills.slice(0, 4).map(bill => <button key={bill.id} onClick={() => navigate(`/bill-detail/${bill.id}`)} className="w-full flex items-center gap-4 px-5 py-4 hover:bg-gray-50 transition-colors text-left" data-id="element-6752">
            
              <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6753">
                <FileTextIcon size={16} className="text-gray-600" data-id="element-6754" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-6755">
                <p className="text-sm font-medium text-gray-900" data-id="element-6756">
                  {bill.supplierName}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-6757">
                  {bill.billNumber} {t("pages.Notifications.due")}{' '}
                  {new Date(bill.dueDate).toLocaleDateString('en-GB')}
                </p>
              </div>
              <div className="text-right flex-shrink-0" data-id="element-6758">
                <p className="text-sm font-semibold text-gray-900" data-id="element-6759">
                  {bill.currency} {bill.amount.toLocaleString()}
                </p>
              </div>
              <ChevronRightIcon size={16} className="text-gray-300 flex-shrink-0" data-id="element-6760" />
            
            </button>)}
          {pendingBills.length > 4 && <button onClick={() => navigate('/bills')} className="w-full px-5 py-3 text-sm font-medium text-[#FF4500] hover:bg-gray-50 transition-colors text-center" data-id="element-6761">
            
              {t("pages.Notifications.view_all")} {pendingBills.length} {t("pages.Notifications.pending_bills")}
            </button>}
        </div>

        {/* Section: Recent Activity */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-6762">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-6763">
            {t("pages.Notifications.recent_activity")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-6764">
          {recentActivity.map(activity => <div key={activity.id} className="flex items-center gap-4 px-5 py-4" data-id="element-6765">
            
              <div className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${activity.color}`} data-id="element-6766">
              
                <activity.icon size={16} data-id="element-6767" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-6768">
                <p className="text-sm font-medium text-gray-900" data-id="element-6769">
                  {activity.title}
                </p>
                <p className="text-xs text-gray-500 mt-0.5" data-id="element-6770">{activity.desc}</p>
              </div>
              <span className="text-xs text-gray-400 flex-shrink-0" data-id="element-6771">
                {activity.time}
              </span>
            </div>)}
        </div>

        {/* Section: System */}
        <div className="px-5 py-3 bg-gray-50 border-b border-gray-200 border-t border-t-gray-200" data-id="element-6772">
          <h3 className="text-xs font-semibold text-gray-600 uppercase tracking-wider" data-id="element-6773">
            {t("pages.Notifications.system_status")}
          </h3>
        </div>
        <div className="divide-y divide-gray-100" data-id="element-6774">
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-6775">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6776">
              <ServerIcon size={16} className="text-gray-600" data-id="element-6777" />
            </div>
            <div className="flex-1" data-id="element-6778">
              <p className="text-sm font-medium text-gray-900" data-id="element-6779">{t("pages.Notifications.api_uptime")}</p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-6780">
                {t("pages.Notifications.all_systems_operational")}
              </p>
            </div>
            <span className="text-sm font-bold text-green-600" data-id="element-6781">99.99%</span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-6782">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6783">
              <RefreshCcwIcon size={16} className="text-gray-600" data-id="element-6784" />
            </div>
            <div className="flex-1" data-id="element-6785">
              <p className="text-sm font-medium text-gray-900" data-id="element-6786">
                {t("pages.Notifications.last_settlement")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-6787">
                {t("pages.Notifications.completed_successfully")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-6788">
              {t("pages.Notifications.0130_am")}
            </span>
          </div>
          <div className="flex items-center gap-4 px-5 py-4" data-id="element-6789">
            <div className="w-9 h-9 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0" data-id="element-6790">
              <LinkIcon size={16} className="text-gray-600" data-id="element-6791" />
            </div>
            <div className="flex-1" data-id="element-6792">
              <p className="text-sm font-medium text-gray-900" data-id="element-6793">
                {t("pages.Notifications.active_payment_links")}
              </p>
              <p className="text-xs text-gray-500 mt-0.5" data-id="element-6794">
                {t("pages.Notifications.currently_receiving_traffic")}
              </p>
            </div>
            <span className="text-sm font-semibold text-gray-900" data-id="element-6795">142</span>
          </div>
        </div>
      </div>
    </div>;
}